import { ResourceProps } from "react-admin";
import { EventsList, EventsShow } from "./components";

export const eventsResource: Omit<ResourceProps, "name"> = {
  list: EventsList,
  show: EventsShow,
};
